export function getSsoConfirmationUrl(currentUrl, path, password) {
	try {
		const url = new URL(currentUrl);
		url.pathname = path;
		url.searchParams.delete('portal_sso_notification');
		url.searchParams.set('confirmed', 'true');
		if (password) {
			url.searchParams.set('password', password);
		}
		return url.toString();
	} catch (error) {
		return false;
	}
}
